// @ts-nocheck
import { jwtDecode } from 'jwt-decode';

export async function handleGoogleSignIn(response: any) {
  interface JwtPayload {
    sub: string;
    email: string;
  }

  const data: JwtPayload = jwtDecode(response.credential);

  await handleSsoSignIn({
    authenticationProvider: 'google',
    token: response.credential,
    userId: data.sub,
    userEmail: data.email,
  });
}

export type AuthenticationProvider = 'google';

export type SSOUserData = {
  userId: string;
  userEmail: string;
  token: string;
  authenticationProvider: AuthenticationProvider;
};

async function generateSHA256Hash(text: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}

async function handleSsoSignIn(data: SSOUserData) {
  if (!window.blueConicClient) {
    return;
  }

  const { userId, userEmail, authenticationProvider } = data;

  // Generate SHA256 hash of email
  const userEmailSHA256 = await generateSHA256Hash(userEmail);

  createCookies({ ...data, userEmail: userEmailSHA256 });

  const profile = window.blueConicClient.profile.getProfile();
  profile.setValue('email', userEmail);
  profile.setValue('email_address_sha256', userEmailSHA256);
  profile.setValue('sso_user_id', userId);
  profile.setValue('sso_provider', authenticationProvider);
  profile.setValue('registration_date', new Date().toISOString());
  profile.setValue('interactions_converted', 'Google oAuth');
  window.blueConicClient.profile.updateProfile();
}

function createCookies({
  token,
  userId,
  authenticationProvider,
  userEmail,
}: SSOUserData) {
  if (typeof document === 'undefined') return;

  document.cookie = `blueconic_auth_token=${token}; path=/; secure; samesite=strict`;
  document.cookie = `blueconic_auth_token_id=${userId}; path=/; secure; samesite=strict`;
  document.cookie = `blueconic_auth_provider=${authenticationProvider}; path=/; secure; samesite=strict`;
  document.cookie = `blueconic_auth_sha256_email=${userEmail}; path=/; secure; samesite=strict`;
}
